import { useEffect, useState } from "react";
// import { WritersData } from "../constants/Writers.js";

import AOS from "aos";
import "aos/dist/aos.css";
import { client } from "../../sanity/client.js";
import { Link } from "react-router-dom";

const Creators = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // *** SANITY CMS FETCH CREATOR CARDS ***
  const [creators, setCreators] = useState([]);

  useEffect(() => {
    const fetchCreators = async () => {
      try {
        const links = await client.fetch(
          `*[_type == "creators"] | order(order asc) {cardName, cardImageUrl, cardUrl}`,
        );
        setCreators(links);
      } catch (error) {
        console.error("Error fetching nav links:", error);
      }
    };

    fetchCreators();
  }, []);
  // *** SANITY CMS FETCH CREATOR CARDS END ***

  return (
    <div className="flex flex-col items-center justify-center min-h-[100vh]">
      <div className="mt-10 flex flex-col justify-center items-center">
        <div className="flex flex-col md:flex-row md:justify-evenly md:mr-5">
          <h1 className="text-5xl md:text-7xl" data-aos="flip-up">
            Creators.
          </h1>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-1 container flex flex-col justify-center items-center mt-5 mb-10 px-2">
        {creators.map((creator, index) => (
          <Link
            key={index}
            to={creator.cardUrl}
            className="text-center shadow-lg relative"
            data-aos="fade-in"
          >
            <img
              src={creator.cardImageUrl}
              alt={"" /* `Image ${index + 1}`*/}
              className="max-w-full transition-opacity duration-300 hover:opacity-70"
              loading="lazy"
              width="600"
              height="500"
            />

            <div className="text-2xl md:text-3xl absolute inset-0 flex justify-center items-center opacity-0 hover:opacity-100 duration-300 transition-opacity">
              <h6 className="text-white"> {creator.cardName}</h6>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Creators;
